import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
let HighchartsChartComponent = /*#__PURE__*/(() => {
  class HighchartsChartComponent {
    constructor(el, _zone // #75
    ) {
      this.el = el;
      this._zone = _zone;
      this.updateChange = new EventEmitter(true);
      this.chartInstance = new EventEmitter(); // #26
    }
    ngOnChanges(changes) {
      const update = changes.update && changes.update.currentValue;
      if (changes.options || update) {
        this.wrappedUpdateOrCreateChart();
        if (update) {
          this.updateChange.emit(false); // clear the flag after update
        }
      }
    }
    wrappedUpdateOrCreateChart() {
      if (this.runOutsideAngular) {
        this._zone.runOutsideAngular(() => {
          this.updateOrCreateChart();
        });
      } else {
        this.updateOrCreateChart();
      }
    }
    updateOrCreateChart() {
      if (this.chart && this.chart.update) {
        this.chart.update(this.options, true, this.oneToOne || false);
      } else {
        this.chart = this.Highcharts[this.constructorType || 'chart'](this.el.nativeElement, this.options, this.callbackFunction || null);
        // emit chart instance on init
        this.chartInstance.emit(this.chart);
      }
    }
    ngOnDestroy() {
      if (this.chart) {
        // #56
        this.chart.destroy();
        this.chart = null;
      }
    }
  }
  HighchartsChartComponent.ɵfac = function HighchartsChartComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HighchartsChartComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  HighchartsChartComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HighchartsChartComponent,
    selectors: [["highcharts-chart"]],
    inputs: {
      Highcharts: "Highcharts",
      constructorType: "constructorType",
      callbackFunction: "callbackFunction",
      oneToOne: "oneToOne",
      runOutsideAngular: "runOutsideAngular",
      options: "options",
      update: "update"
    },
    outputs: {
      updateChange: "updateChange",
      chartInstance: "chartInstance"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 0,
    vars: 0,
    template: function HighchartsChartComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
  return HighchartsChartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HighchartsChartModule = /*#__PURE__*/(() => {
  class HighchartsChartModule {}
  HighchartsChartModule.ɵfac = function HighchartsChartModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HighchartsChartModule)();
  };
  HighchartsChartModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: HighchartsChartModule
  });
  HighchartsChartModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return HighchartsChartModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of highcharts-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HighchartsChartComponent, HighchartsChartModule };
